import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { ISidebarProps, SectionId } from '../types';

export const BottomNav = ({ activeSection }: ISidebarProps) => {
    const navigate = useNavigate();
    const handleNavClick = (e: React.MouseEvent<HTMLButtonElement>, targetId: SectionId) => {
        try {
            e.preventDefault();
            const to: Record<SectionId, string> = {
                dashboard: '/',
                analysis: '/analytics',
                artists: '/artists',
                agenda: '/agenda',
                workflow: '/workflow',
            };
            navigate(to[targetId] || '/');
        } catch (error) {
            console.error('Navigation error:', error);
        }
    };

    const navItems: { id: SectionId; title: string; icon: string }[] = [
        { id: 'dashboard', title: 'Dashboard', icon: 'ph-grid-four' },
        { id: 'analysis', title: 'Análise IA', icon: 'ph-brain' },
        { id: 'artists', title: 'Artistas', icon: 'ph-users' },
        { id: 'workflow', title: 'Workflow', icon: 'ph-calendar' },
    ];

    return (
        <nav className="fixed bottom-0 left-0 right-0 h-16 lg:hidden z-20 bottom-nav-glass">
            <ul className="flex justify-around items-center h-full max-w-lg mx-auto">
                {navItems.map(item => (
                    <li key={item.id}>
                        <button
                            type="button"
                            aria-label={item.title}
                            onClick={(e) => handleNavClick(e, item.id)}
                            className={`bottom-nav-link group relative flex items-center justify-center p-3 rounded-lg transition-colors duration-200 hover:bg-black/5 dark:hover:bg-white/10 focus-visible:bg-black/5 dark:focus-visible:bg-white/10 focus-visible:outline-none ${activeSection === item.id ? 'active' : ''}`}
                            aria-current={activeSection === item.id ? 'page' : undefined}
                        >
                            <i className={`ph ${item.icon} text-2xl w-6 text-center transition-all duration-200 ${activeSection === item.id ? 'text-[#1DB954] scale-110' : 'text-zinc-500 dark:text-zinc-400 group-hover:text-zinc-800 dark:group-hover:text-white group-focus-visible:text-zinc-800 dark:group-focus-visible:text-white'}`}></i>
                            <span className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 px-3 py-1.5 bg-zinc-800 dark:bg-zinc-900 border border-zinc-700 text-white text-xs font-semibold rounded-md shadow-lg opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-30">
                                {item.title}
                            </span>
                        </button>
                    </li>
                ))}
            </ul>
        </nav>
    );
};


